import React from 'react';
import { useCategory } from '../components/CategoryContext';
import { useParams, Link} from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import '../styles/CustomButton.css';

const Category = () => {
  const { categories} = useCategory();
  const { groupId } = useParams();
  
  // Фильтруем категории по groupId
  const filteredCategories = categories.filter((item) => item.group === groupId);
  

  return (
    <Container className="mt-3">
      <h2>Элементы категории</h2>
      <Row>
        {filteredCategories.map((category) => (
          <Col key={category.id} xs={12} sm={6} md={4} lg={3}>
            <Card style={{ width: '18rem', margin: '10px' }}>
              <Card.Img variant="top" height={250} src={category.image} />
              <Card.Body>
                <Card.Title>{category.name}</Card.Title>
                <Card.Text style={{ height: '100px', overflow: 'hidden' }}>{category.description}</Card.Text>
                 <Link to={`/categori/${encodeURIComponent(category.url)}`}>
                  <Button className='mb-2 CustomButton' variant="primary">
                    Перейти к элементу
                  </Button>
                </Link>
                
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Category;
